"use client";
import { message } from "antd";
import axios from "axios";
import { useState } from "react"; // Removed useEffect since we're using queries
import toast from "react-hot-toast";
import RightArrowIcon from "../icons/RightArrowIcon";
import { logError } from "../../../lib/sentry";
import LoadingButtonAnimation from "../../ui/LoadingButtonAnimation";
import { useRouter } from "next/navigation";
import apiConfig from "../../../lib/config";
import Cookies from "js-cookie";
const TripAuditSection = () => {
  const router = useRouter();
  const [tripId, setTripId] = useState("");
  const [loading, setLoading] = useState(false);

  // ===============================================================
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!tripId.trim()) {
      message.error("Please enter a valid Drive ID or email.");
      return;
    }

    setLoading(true);

    try {
      // 🔥 Call the GET API manually
      // Replace the endpoint with the real one from your usePasswordSetupInfo hook
      const res = await axios.get(
        `${apiConfig.api.baseUrl}/check_trip_or_email`, // ← change this if needed
        {
          params: {
            field_input: tripId, // or email — backend will accept both
          },
        },
      );
      const token = Cookies.get("auth_token");
      // Success (200)
      if (res.status === 200 && res?.data?.exists) {
        if (token) {
          router.push(
            `/purchase-plan-list?driveId=${encodeURIComponent(res?.data?.trip_id)}`,
          );
        } else {
          router.push(
            `/auth/setup-password?tripId=${encodeURIComponent(res?.data?.trip_id)}`,
          );
        }
        return;
      }
      // If status is not 200
      toast.error(res.data?.message || "Something went wrong");
    } catch (error) {
      const msg =
        axios.isAxiosError(error) && error.response
          ? error.response.data?.error ||
            error.response.data?.message ||
            "Something went wrong"
          : "Network error. Please try again.";

      logError(error, {
        feature: "password-setup",
        action: "get_password_setup_info",
        extra: {
          tripIdOrEmail: tripId,
          endpoint: `/password_setup_info`,
        },
      });

      toast.error(msg);
      message.error(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="py-5 z-100">
        <form
          onSubmit={handleSubmit}
          className="space-y-6 max-w-200 mx-auto w-full"
        >
          <div className="flex items-center flex-col md:flex-row gap-5 ">
            <div className="relative w-full">
              <input
                type="text"
                id="tripId"
                value={tripId}
                onChange={(e) => setTripId(e.target.value.trim())}
                className="w-full px-4 py-3  bg-white  rounded-lg  placeholder-white outline-none peer text-[#303030]"
                required
              />
              <label
                htmlFor="tripId"
                className="bg-white absolute left-1.5 bottom-3 peer-focus:text-[#0336BC] peer-focus:-translate-y-6 transition-all text-[16px] text-[#7D7D7D] font-openSans leading-6 peer-focus:rounded-md peer-focus:px-1 peer-focus:text-[14px]"
              >
                Enter your Drive ID or Email
              </label>
              {loading ? (
                <div className="absolute right-0 top-1/2 md:hidden -translate-y-1/2 bg-blue-600 h-12 px-3 py-2 rounded-md w-20">
                  <LoadingButtonAnimation />
                </div>
              ) : (
                <button
                  type="submit"
                  disabled={loading}
                  className={`absolute right-0 top-1/2 md:hidden -translate-y-1/2 bg-blue-600 hover:bg-blue-700 text-white font-semibold h-12 px-3 py-2 transition-colors disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-0 rounded-r-md`}
                >
                  {/* {loading ? <LoadingButtonAnimation /> : "Continue"} */}
                  <RightArrowIcon size={28} />
                </button>
              )}
              <button
                type="submit"
                disabled={loading}
                className=" bg-blue-600 absolute right-0 h-full top-0 w-full md:w-auto hidden md:block  text-white font-semibold py-3 px-4 rounded-r-md "
              >
                {loading ? <LoadingButtonAnimation /> : "Continue"}
              </button>
            </div>
          </div>
        </form>
      </div>
    </>
  );
};

export default TripAuditSection;
